// hooks/useItemFilters.js - COMPLETO
import { useCallback } from 'react';
import { isItemInList as checkItemInList, isToday as checkToday, getDaysSinceLastUsed } from '../utils/itemUtils';

export const useItemFilters = () => {
  const filterItemsByList = useCallback((items) => {
    return items.filter(item => checkItemInList(item));
  }, []);

  const filterItemsBySearch = useCallback((items, searchTerm) => {
    if (!searchTerm.trim()) return items;
    
    const term = searchTerm.toLowerCase().trim();
    return items.filter(item => 
      item.item.toLowerCase().includes(term)
    ).sort((a, b) => {
      const aStartsWith = a.item.toLowerCase().startsWith(term);
      const bStartsWith = b.item.toLowerCase().startsWith(term);
      
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      return a.item.localeCompare(b.item);
    });
  }, []);

  const groupItemsByCategory = useCallback((items, availableCategories = []) => {
    const grouped = items.reduce((groups, item) => {
      const category = item.category || 'others';
      if (!groups[category]) groups[category] = [];
      groups[category].push(item);
      return groups;
    }, {});

    const sortedCategories = Object.keys(grouped).sort((a, b) => {
      const indexA = availableCategories.indexOf(a);
      const indexB = availableCategories.indexOf(b);
      
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });

    return { grouped, sortedCategories };
  }, []);

  const getItemsInListCount = useCallback((items) => {
    return items.filter(item => checkItemInList(item)).length;
  }, []);

  const isItemInList = useCallback((item) => {
    return checkItemInList(item);
  }, []);

  const isToday = useCallback((dateString) => {
    return checkToday(dateString);
  }, []);

  return {
    filterItemsByList,
    filterItemsBySearch,
    groupItemsByCategory,
    getItemsInListCount,
    getDaysSinceLastUsed,
    isItemInList,
    isToday
  };
};